import {Navigate, Outlet} from "react-router-dom";
import {useStateContext} from "../../contexts/ContextProvider";
import {Transition} from "@headlessui/react";
import React, {Fragment} from "react";
import {CheckCircleIcon} from "@heroicons/react/16/solid";
import {XMarkIcon} from "@heroicons/react/24/outline";
export default function GuestLayout() {

    const {token, notifications, setNotifications} = useStateContext();

    if(token){
        return <Navigate to={"/"}/>
    }

    return (
        <div className="h-full">
            <div aria-live="assertive"
                 className="pointer-events-none fixed inset-0 z-[9999] flex items-end px-4 py-6 sm:items-start sm:p-6">
                <div className="flex w-full flex-col items-start space-y-4">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    <Transition
                        show={!!notifications}
                        as={Fragment}
                        enter="transform ease-out duration-300 transition"
                        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div
                            className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="p-4">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        {notifications?.success &&
                                            <CheckCircleIcon className="h-6 w-6 text-green-400"
                                                             aria-hidden="true"/>}
                                        {notifications?.error &&
                                            <XMarkIcon className="h-6 w-6 text-red-400" aria-hidden="true"/>}
                                    </div>
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className=" text-sm text-gray-500">
                                            {notifications?.success}
                                            {notifications?.error}
                                        </p>
                                    </div>
                                    <div className="ml-4 flex flex-shrink-0">
                                        <button
                                            type="button"
                                            className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                            onClick={() => {
                                                setNotifications(null)
                                            }}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-5 w-5" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
            <Outlet/>
        </div>
    )
}
